import styled from 'styled-components';
import { Toggle } from '@veneer/core';
import { tokens } from '@veneer/tokens';

export const StyledToggle = styled(Toggle)`
  span[aria-checked] {
    width: 40px !important;
    height: 20px !important;
  }

  span[aria-checked='true'] {
    background-color: ${tokens.color.royalBlue7} !important;
    border-color: ${tokens.color.royalBlue7} !important;

    &:active {
      background-color: ${tokens.color.royalBlue7} !important;
      border-color: ${tokens.color.royalBlue7} !important;
    }

    &:hover {
      background-color: ${tokens.color.royalBlue8} !important;
      border-color: ${tokens.color.royalBlue8} !important;
    }

    &:before {
      left: calc(50% + 10px);
    }
  }

  span[aria-checked='false'] {
    &:before {
      left: calc(50% - 10px);
    }
  }
`;

export const Container = styled.div`
  background-color: ${tokens.color.white};
  display: flex;
  gap: 20px;
  width: 100%;
  min-height: 100vh;
  flex-direction: column;
  padding: 24px;
  overflow-y: auto;
  box-sizing: border-box;
  direction: ${(props) => (props.isRTL ? 'rtl' : 'ltr')};
  gap: 20px;

  a {
    color: ${tokens.color.royalBlue7};

    &:hover {
      color: ${tokens.color.royalBlue6};
    }
  }
`;

export const ConsentToggleItem = styled.div`
  display: flex;
  margin-top: 12px;
  flex-direction: column;
  gap: 16px;
`;

export const ConsentToggleItemTitle = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ConsentToggleTitle = styled.div`
  display: flex;
  align-items: left;
  gap: 4px;
`;

export const ConsentDescription = styled.div`
  body {
    margin-bottom: 12px;
  }
`;
